const ArrowChevronUp = () => (
  <svg width="17" height="10" viewBox="0 0 17 10" xmlns="http://www.w3.org/2000/svg">
    <g
      transform="matrix(-1 0 0 1 15.7 1) matrix(-1 0 0 1 14 0)"
      stroke="#2F2F30"
      strokeWidth="1.4"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <path transform="matrix(0 1 1 0 -.5 .5)" d="M-.5.5 7.5 7.5" />
      <path transform="matrix(0 1 1 0 6.4 -6.4)" d="M6.4 7.5 14.4.5" />
    </g>
  </svg>
);

export default ArrowChevronUp;
